module.exports = __webpack_public_path__ + "static/media/evolution_img2.e9300818.png";